import { render } from "./ablilit-btn.vue?vue&type=template&id=039dbce6&scoped=true&ts=true"
import script from "./ablilit-btn.vue?vue&type=script&lang=ts"
export * from "./ablilit-btn.vue?vue&type=script&lang=ts"

import "./ablilit-btn.vue?vue&type=style&index=0&id=039dbce6&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039dbce6"]])

export default __exports__